module.exports = __webpack_public_path__ + "static/pi-lab-pano-4c0dd4dd2561fbef1a5118e948479475.jpg";